import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { UncontrolledTable } from '~/components';

const statusToColor = status => {
  if (status === 'Enrolled') {
    return 'success';
  } else if (status === 'Declined') {
    return 'danger';
  }
  return 'warning';
};

const OutboundReferralTable = ({
  columns,
  defaultSorted,
  params,
  combineName,
  ...rest
}) => {
  const location = useLocation();
  const isPatientRoute = () => location.pathname.includes('/patients/');

  const cols = columns || [{
    id: 'clientName',
  }, {
    id: 'providerRoleName',
    Header: 'Specialty',
    accessor: 'attributes.providerRoleName',
  }, {
    id: 'eventDate',
    Header: 'Referral Date',
    accessor: 'attributes.eventDate',
    cellType: 'date',
  }, {
    id: 'priorityLabel',
    Header: 'Priority Label',
    accessor: 'attributes.priorityLabel',
  }, {
    id: 'toDivisionName',
    Header: 'To Division',
    accessor: 'attributes.toDivisionName',
  }, {
    id: 'toDisplayName',
    Header: 'To Provider',
    accessor: 'attributes.toDisplayName',
  }, {
    id: 'facilityName',
    Header: 'To Facility',
    accessor: 'attributes.facilityName',
  }, {
    id: 'fromDisplayName',
    Header: 'From Provider',
    accessor: 'attributes.fromDisplayName',
  }, {
    id: 'status',
    Header: 'Referral Status',
    accessor: 'attributes.statusLabel',
    Cell: v => (
      <div className="d-flex justify-content-center align-items-center">
        <Badge
          color={statusToColor(v.original.attributes.statusLabel)}
          className="rounded-pill p-3"
        >
          {v.original.attributes.statusLabel}
        </Badge>
      </div>
    ),
  }];

  const nameFields = combineName ?
    [{
      id: 'lastName,firstName',
      omit: isPatientRoute,
      Header: 'Client',
      accessor: i => `${i.attributes.lastName}, ${i.attributes.firstName}`,
    }] : [{
      id: 'firstName',
      omit: isPatientRoute,
      Header: 'First Name',
      accessor: 'attributes.firstName',
    }, {
      id: 'lastName',
      omit: isPatientRoute,
      Header: 'Last Name',
      accessor: 'attributes.lastName',
    }];

  cols.splice(cols.findIndex(i => i.id === 'clientName'), 1, ...nameFields);

  return (
    <UncontrolledTable
      name="outbound-referral"
      endpoint={{
        url: 'data/public/nav-list-view-outbound-referral',
        params,
      }}
      columns={cols}
      defaultSorted={defaultSorted}
      {...rest}
    />
  );
};

OutboundReferralTable.propTypes = {
  params: PropTypes.shape(),
  columns: PropTypes.arrayOf(PropTypes.shape()),
  defaultSorted: PropTypes.arrayOf(PropTypes.shape()),
  combineName: PropTypes.bool,
};

OutboundReferralTable.defaultProps = {
  params: {},
  columns: undefined,
  defaultSorted: [{ id: 'eventDate', desc: true }],
  combineName: false,
};

export default OutboundReferralTable;
